'use client';

import type { AuthorPortfolio } from '@/modules/Author/interface/Author';
import type { FC } from 'react';
import { Flex, Heading, Skeleton } from '@eqi-investimentos/react';
import { Accordion } from '@chakra-ui/react';
import { useT } from '@/libs/i18n/utils/useT';
import { RecommendedWalletItem } from '@/modules/Research/ui/RecommendedWallets/RecommendedWalletItem';

export const AuthorRecommendations: FC<AuthorRecommendationsProps> = ({
  authorName,
  recommendations,
  isLoading,
}) => {
  const t = useT();

  if (isLoading) {
    return (
      <Flex flexDir="column" gap="l">
        <Skeleton w="18.75rem" h="1.25rem" borderRadius="0.1875rem" />
        <Flex flexDir="column" gap="l">
          <Skeleton w="full" h="21.875rem" borderRadius="0.1875rem" />
        </Flex>
      </Flex>
    );
  }

  if (!recommendations.length) {
    return <></>;
  }

  return (
    <Flex flexDir="column" gap="l" pr="3.25rem">
      <Heading
        as="h3"
        w="full"
        fontSize="lg"
        fontWeight="normal"
        color="content.primary"
        textAlign="left"
      >
        {`${t('attributes.wallets')} ${t('attributes.of')} ${authorName.split(' ')[0]}`}
      </Heading>
      <Accordion
        defaultIndex={[0]}
        allowMultiple
        display="flex"
        flexDir="column"
        gap="1.875rem"
      >
        {recommendations.map(({ assets, id, title }) => (
          <RecommendedWalletItem key={id} title={title} assets={assets} />
        ))}
      </Accordion>
    </Flex>
  );
};

type AuthorRecommendationsProps = {
  authorName: string;
  recommendations: AuthorPortfolio[];
  isLoading?: boolean;
};
